import React, { Suspense } from "react";
import Navbar from "../layouts/front/Navbar";
import frontRoutes from "../routes/frontRoutes";
import { Navigate, Route, Routes } from "react-router-dom";
import Sidebar from "../layouts/front/Sidebar";
import ProtectedRoute from "./Common/ProtectedRoute";
import { ClipLoader } from "react-spinners";

// Shown while a lazy-loaded route chunk is being fetched.
const RouteLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "60vh",
    }}
  >
    <ClipLoader color={"#123abc"} size={36} />
  </div>
);

function Home() {
  return (
    <section className="main-layout">
      <Navbar />
      <section id="layoutSidenav" className="content-wrapper">
        <div className="nav-overlay">
          <button
            type="button"
            onClick={(e) => {
              document.body.classList.remove("menu-open");
            }}
          ></button>
        </div>
        <aside id="layoutSidenav_nav" className="sidebar">
          <Sidebar />
        </aside>
        <main id="layoutSidenav_content" className="main-content">
          <Suspense fallback={<RouteLoader />}>
            <Routes>
              {frontRoutes
                .filter((route) => route.component)
                .map(({ path, component, permission }, idx) => (
                  <Route
                    key={idx}
                    path={path}
                    element={
                      <ProtectedRoute
                        component={component}
                        permission={permission}
                      />
                    }
                  />
                ))}
              <Route path="/" element={<Navigate to="/campaign_listing" />} />
            </Routes>
          </Suspense>
        </main>
      </section>
    </section>
  );
}

export default Home;
